import React, { useState } from "react";
import { Box, Card, Grid } from "@mui/material";
import defaultProjectImage from "../../assets/images/placeholder_img.jpg";
import StarIcon from "@mui/icons-material/Star";
import ProjectPhotosModal from "./ProjectPhotosModal";
import { BIGrey } from "../../assets/helpers";
import { English } from "../../constant/EnglishFallback";
import { useSelector } from "react-redux";
import Emptydata from "../common/Emptydata";
import ImageIcon from "@mui/icons-material/Image";
import Loader from "../../common/Loader";

const ProjectPhotosSection = ({ photos, isLoading, getUpdatedPhotos, projectDetails }) => {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const [showPhotosModal, setShowPhotosModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const { TEXT_NO_PHOTOS = English.ProjectPhotosSection.TEXT_NO_PHOTOS } =
    multiLanguageData?.ProjectPhotosSection || {};

  const NoInformation = () => {
    return (
      <Box className="empty-data-card">
        <Emptydata icon={<ImageIcon className="emptydata-icon" />} firstText={TEXT_NO_PHOTOS} />
      </Box>
    );
  };

  const renderPhotos = () => {
    return (
      <Box>
        {photos?.length > 0 ? (
          <Grid container spacing={1} columns={{ xs: 12, md: 12 }}>
            {photos?.map((image, index) => (
              <Grid
                key={index}
                size={{ xs: 4, md: 4 }}
                sx={{ height: { xs: 150, md: 200, position: "relative" } }}>
                {image?.isFavorite && (
                  <StarIcon
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      color: "#fff",
                      zIndex: 1,
                      backgroundColor: "grey",
                      borderRadius: "50%"
                    }}
                  />
                )}
                <img
                  onError={(e) => {
                    e.target.src = defaultProjectImage;
                  }}
                  key={index}
                  src={image?.pictureUrl}
                  onClick={() => {
                    setSelectedIndex(index);
                    setShowPhotosModal(true);
                  }}
                  alt={`Image ${index}`}
                  style={{
                    cursor: "pointer",
                    height: "100%",
                    width: "100%",
                    objectFit: "cover"
                  }}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <NoInformation />
        )}
      </Box>
    );
  };

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2 }}>
        {isLoading ? <Loader /> : renderPhotos()}
        {showPhotosModal && (
          <ProjectPhotosModal
            open={showPhotosModal}
            onClose={() => {
              setSelectedIndex(null);
              setShowPhotosModal(false);
            }}
            selectedIndex={selectedIndex}
            photos={photos ?? []}
            getUpdatedPhotos={getUpdatedPhotos}
            projectDetails={projectDetails}
          />
        )}
      </Card>
    </Box>
  );
};

export default ProjectPhotosSection;
